/**
 * Index file for program-steps hooks
 * Re-exports all hooks from individual files for easier imports
 */

// Step 1: Basic Configuration
// Currently no specific hooks for this step

// Step 2: Program Customer Setup
export * from './useCustomer';

// Step 3: Role
export * from './useRoles';

// Step 4: PDIU
export * from './usePdiu';

// Step 5: Program Customer Level
export * from './useCustomerLevel';

// Step 6: Phases
export * from './useProgramPhase';

// Step 7: Assets
export * from './useAssets';

// Step 8: Activity
export * from './useActivities';

// Step 9: Feedback
export * from './useFeedback';

// Timeline
export * from './useTimeline';

// Misc
export * from './useMisc';
